import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useDarkMode from "../../hooks/useDarkMode";
import { guestToken, login } from "../../redux/auth/actions";
import { useAppDispatch } from "../../hooks/hooks";
import { useSelector } from "react-redux";
import { userProfile } from "../../redux/userProfile/action";
import { useForm } from "react-hook-form";
import storePersist from "../../redux/storePersist";
import _ from "lodash";
import { toast } from "react-toastify";
import { settings } from "../../redux/settings/actions";
import EmailInput from "../../common/components/form/EmailInput.Component";
import { RotatingLines } from "react-loader-spinner";
import PasswordInput from "../../common/components/form/PasswordInput.Component";
import { selectChannelListItems } from "../../redux/channel/selector";

export default function IxeLogin() {
	const navigate = useNavigate()
	const dispatch = useAppDispatch()
	const channelListItem = useSelector(selectChannelListItems)
	const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
	const [baseURL, setBaseUrl] = useState('');
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [steps, setSteps] = useState({ Email: '', Password: '' })
	const [loginValues, setLoginValues] = useState<any>()
	const [selectedLoginType, setSelectedLoginType] = useState<string>(""); // dropdown
	const loginTypeRef = useRef<HTMLSelectElement | null>(null);
	const loginErrorRef = useRef<HTMLParagraphElement | null>(null);
	const [isLoginWithOTP, setIsLoginWithOTP] = React.useState(false)

	const [colorTheme, setTheme] = useDarkMode();
	const [darkSide, setDarkSide] = useState(
		colorTheme === "light" ? true : false
	);
	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};
	const toggleDarkMode = (checked: any) => {
		setTheme(colorTheme);
		setDarkSide(checked);
	};
	const handleSteps = (e: any, key: any) => {
		setSteps({ ...steps, [key]: e.target.value })
	}

	const handleChange: any = (event: any, field: string) => {
		setLoginValues({ ...loginValues, [field]: event })
	}

	const image1 = require("../../assets/img/bg.jpg");
	const image2 = require("../../assets/img/digiit.ai.png");

	const gotoHome = async (role: any) => {
		switch (role?.toLowerCase()) {
			case 'trainer':
				navigate("/trainer/login")
				break;
			case 'management':
				navigate("/auth/login/management")
				break;
			case 'agency':
				navigate("/agencies/login")
				break;
			case 'partner':
				navigate("/partner/login")
				break;
			default:
				navigate("/dsap-agency/dashboards")
		}
	}

	const handleForgotPassword = (e: any) => {
		e.preventDefault();
		storePersist.set('reset-pwd', 'dsa')
		navigate('/login/forgot-password')
	}

	const getLoginPayload = (type: string, metaData: any) => {
		const Email = steps?.Email;
		const Password = steps?.Password;
		const OUId = metaData?.current?.items?.Website?.OUId;

		switch (type.toLowerCase()) {
			case "management":
				return {
					"Records": [
						{
							"Context": {
								"Subscription": "One-X",
								"Domain": "ONE",
								"SubDomains": [],
								"Network": "Internal",
								"Application": "Management",
								"Channel": "Portal"
							},
							"Message": {
								"Username": steps?.Email,
								"Password": steps?.Password,
								"AccountType": "Internal",
								"LoginWithOtp": false,
								"Otp": "",
								"IsGoogleAuthenticated": false,
								"AuthenticatedUserId": "",
								"ClientIPAddress": "",
								"OrganizationUnitId": 0
							}
						}
					]
				};
			case "agency":
				return {
					"Records": [
						{
							"Context": {
								"Subscription": "ONE",
								"Domain": "ONE",
								"SubDomains": [],
								"Network": "ONEServiceProvider",
								"Application": "ONE Service Provider",
								"Channel": "CSP"
							},
							"Message": {
								"Username": steps?.Email,
								"Password": steps?.Password,
								"AccountType": "ONEServiceProvider",
								"LoginWithOtp": false,
								"Otp": "",
								"IsGoogleAuthenticated": false,
								"AuthenticatedUserId": "",
								"ClientIPAddress": "",
								"OrganizationUnitId": metaData?.current?.items?.Website?.OUId
							}
						}
					]
				};
			case "partner":
				return {
					"Records": [
						{
							"Context": {
								"Subscription": "ONE",
								"Domain": "ONE",
								"SubDomains": [],
								"Network": "ONEPartner",
								"Application": "ONEPartner",
								"Channel": "CSP"
							},
							"Message": {
								"Username": steps?.Email,
								"Password": steps?.Password,
								"AccountType": "ONEPartner",
								"LoginWithOtp": isLoginWithOTP,
								"Otp": loginValues?.otp || '',
								"IsGoogleAuthenticated": false,
								"AuthenticatedUserId": "",
								"ClientIPAddress": "",
								"OrganizationUnitId": metaData?.current?.items?.Website?.OUId
							}
						}
					]
				};
			default: // Trainer
				return {
					"Records": [
						{
							"Context": {
								"Subscription": "ONE",
								"Domain": "ONE",
								"SubDomains": [],
								"Network": "Trainer",
								"Application": "Trainer",
								"Channel": "CSP"
							},
							"Message": {
								"Username": steps?.Email,
								"Password": steps?.Password,
								"AccountType": "Trainer",
								"LoginWithOtp": false,
								"Otp": "",
								"IsGoogleAuthenticated": false,
								"AuthenticatedUserId": "",
								"ClientIPAddress": "",
								"OrganizationUnitId": metaData?.current?.items?.Website?.OUId
							}
						}
					]
				};
		}
	};

	const handleRoleRedirect = async (loginType: string, roles: any[]) => {
		let matchedRole = "";

		const roleMap = {
			management: ["businessowner"],
			partner: ["onepartner"],
			agency: ["oneserviceprovider"],
			trainer: ["trainer"]
		};

		const expectedRoles = roleMap[loginType.toLowerCase()] || roleMap["agency"];

		roles.find((element: any) =>
			element?.Message?.Roles.find((role: any) => {
				if (expectedRoles.includes(role?.Name?.toLowerCase())) {
					matchedRole = role.Name.toLowerCase();
					return true;
				}
				return false;
			})
		);

		// Redirect logic
		switch (loginType.toLowerCase()) {
			case "management":
				return matchedRole === "businessowner"
					? navigate("/management/e-advisor/dashboards")
					: navigate("/");
			case "partner":
				return matchedRole === "onepartner"
					? navigate("/partner/home") : navigate("/") // Or another route for agents
			case "trainer":
				return matchedRole === "trainer"
					? navigate("/trainer/home") : navigate("/") // Optional
			case "agency":
				return matchedRole === "oneserviceprovider"
					? navigate("/agencies/home") : navigate("/") // Optional
			default:
				return navigate("/dsap-agency/dashboards");
		}
	};

	const onFinish = async () => {
		if (!selectedLoginType) {
			if (loginErrorRef.current) loginErrorRef.current.style.display = "block";
			loginTypeRef.current?.focus();
			return;
		}

		setIsLoading(true);
		try {
			const metaData: any = storePersist.get("metaTokenMetaData");

			const loginType = selectedLoginType
			const loginPayload = getLoginPayload(loginType, metaData);

			await dispatch(login({ loginData: loginPayload }));

			const resp = await dispatch(userProfile.read({
				url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/user-service/user-profile/me`,
				entity: 'userProfile'
			}));

			await handleRoleRedirect(loginType, resp);
		} catch (e: any) {
			toast.error(e?.Error?.Message || "There was an error in login. Please try again...");
			console.error("Login failed:", e?.Error?.Message);
		}
		setIsLoading(false);
	};

	const startGoogleAuthentication = () => {
		storePersist.set('google-login-role', 'businessowner')
		const guestToken = localStorage.getItem("guest-token");
		const url = `${process.env.REACT_APP_API_URL}/googleauth/SignInWithGoogle?guest_token=${guestToken}&ClientRedirectUrl=${baseURL}`
		window.location.href = url;
	}

	const handleRegistration = () => {
		dispatch(settings.set({ getRegistry: 'open' }))
		navigate('/register-dsap-agency')
	};

	useEffect(() => {
		setBaseUrl(window.location.origin);
		clearErrors('Email')
		clearErrors('Password')
	}, [])

	return (
		<form onSubmit={handleSubmit(onFinish)}>
			<div className="flex min-h-screen w-screen overflow-hidden bg-gradient-to-r from-blue-50 via-white to-blue-100">


				<div className="w-full hidden md:block relative">
					<img
						src={image1}
						alt="IIMB Building"
						className="w-full h-full object-cover"
					/>
					<div className="absolute inset-0 bg-blue-900 bg-opacity-40 flex items-center justify-center">
						<h1 className="text-white text-4xl font-bold drop-shadow-lg">
							Welcome to iXE
						</h1>
					</div>
				</div>


				<div className="w-full md:w-1/2 flex justify-center items-center">
					<div className="backdrop-blur-xl bg-blue/100 shadow-2xl rounded-2xl max-w-md w-full px-8 py-10">


						<div className="flex justify-center mb-6">
							<img src={image2} alt="Digiit Logo" className="h-12" />
						</div>

						<h2 className="text-3xl font-bold text-center mb-6 text-gray-800">
							Sign in to your account
						</h2>


						<EmailInput
							label="E-mail"
							name="Email"
							isRequired={true}
							register={register}
							errors={errors}
							setValue={setValue}
							handleSteps={(e) => handleSteps(e, "Email")}
						/>


						<PasswordInput
							label="Password"
							name="Password"
							isRequired={true}
							register={register}
							errors={errors}
							setValue={setValue}
							handleSteps={(e) => handleSteps(e, "Password")}
						/>


						<div className="flex flex-col mt-2 text-sm space-y-2">
							<a
								href="#"
								onClick={handleForgotPassword}
								className="text-blue-600 hover:text-blue-800 hover:underline self-start transition"
							>
								Forgot password?
							</a>


							<select
								ref={loginTypeRef}
								onChange={(e) => {
									setSelectedLoginType(e.target.value);
									if (loginErrorRef.current) loginErrorRef.current.style.display = "none";
								}}
								className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
								defaultValue=""
							>
								<option value="" disabled>Select login type</option>
								<option value="management">iXE Management</option>
								<option value="agency">iXE Agency</option>
								<option value="partner">iXE Partner</option>
								<option value="trainer">iXE Catalyst</option>
							</select>

							<p ref={loginErrorRef} className="text-red-600 text-sm mt-1 hidden">
								Please select the application you want to launch.
							</p>
						</div>


						<button
							type="submit"
							disabled={isLoading}
							className={`mt-6 bg-gradient-to-r from-blue-600 to-blue-700 text-white w-full py-2 rounded-lg shadow-md hover:scale-[1.02] transition-transform duration-300 ${isLoading && "opacity-60"}`}
						>
							{isLoading ? (
								<RotatingLines visible={true} width="20" strokeColor="#fff" />
							) : (
								"Sign in"
							)}
						</button>


						<div className="my-6 flex items-center text-gray-500 text-sm">
							<hr className="flex-grow border-gray-300" />
							<span className="mx-2">Or continue with</span>
							<hr className="flex-grow border-gray-300" />
						</div>


						<div className="flex flex-col space-y-3">
							<button
								type="button"
								className="border border-gray-300 py-2 rounded-lg text-sm flex items-center justify-center hover:bg-gray-100 transition"
								onClick={() => {

								}}
							>
								📱 Sign in with OTP
							</button>
							<button
								type="button"
								onClick={startGoogleAuthentication}
								className="border border-gray-300 py-2 rounded-lg text-sm flex items-center justify-center hover:bg-gray-100 transition"
							>
								🌐 Sign in with Google
							</button>
						</div>


						<div className="mt-6 text-xs text-center text-gray-500">
							<p>Terms of use • Privacy policy</p>
							<p className="mt-1">
								This site is protected by Digiit Business Services{" "}
								<a href="https://policies.google.com/privacy" className="underline">
									Privacy Policy
								</a>{" "}
								and{" "}
								<a href="https://policies.google.com/terms" className="underline">
									Terms of Service
								</a>{" "}
								apply.
							</p>
						</div>
					</div>
				</div>
			</div>
		</form>
	);

}
